var ua = navigator.userAgent.toLowerCase();

const isSafari = () => {
  if (ua.indexOf('safari') != -1) {
    if (ua.indexOf('chrome') > -1) {
      return false;
    } else {
      return true;
    }
  }
}

const isChrome = () => {
  if (ua.indexOf('chrome') != -1) {
    if (ua.indexOf('safari') > -1) {
      return false;
    } else {
      return true;
    }
  }
}


export { isSafari, isChrome };
